import CreditCard from "../../payments/models/CreditCard";
import DateHelper from "../../../services/DateHelper";

export class PlanInfo {
  constructor(data) {
    this.nextDue = data.nextDue;
    this.nextDueDate = data.nextDueDate ? DateHelper.createDate(data.nextDueDate) : null;
    this.nextAnnualFee = data.nextAnnualFee;
    this.nextAnnualFeeDate = data.nextAnnualFeeDate ? DateHelper.createDate(data.nextAnnualFeeDate) : null;
  }

  getFormattedNextDueDate() {
    return this.nextDueDate ? this.nextDueDate.toLocaleDateString() : "";
  }

  getFormattedAnnualFeeDate() {
    return this.nextAnnualFeeDate ? this.nextAnnualFeeDate.toLocaleDateString() : "";
  }
}

export class Member {
  id;
  first_name;
  last_name;
  email;
  phone_number;
  membership_type;
  membership_status;
  membership_start;
  membership_end;
  payment_option;
  payment_interval;
  barcode;
  club;
  created_at;
  default_card;
  show_cancel;
  show_cancel_pt;
  can_update_payment;
  membership_plan_info;
  membership_agreement_status;
  is_freezed;

  constructor(props) {
    Object.assign(this, props);
    this.club = new Club(props.club);
    this.created_at = DateHelper.createDate((this.created_at));
    this.membership_start = DateHelper.createDate((this.membership_start));
    this.membership_end = DateHelper.createDate((this.membership_end));
    this.default_card = new CreditCard(props.card_last_four ? {last_four: props.card_last_four} : null);
    this.plan_info = props.membership_plan_info ? new PlanInfo(props.membership_plan_info) : null;
  }

  getPaymentInterval() {
    return this.payment_option || this.payment_interval;
  }

  getFormattedEnd() {
    return this.membership_end.toLocaleDateString();
  }

  getFormattedStart() {
    return this.membership_start.toLocaleDateString();
  }

  canOpenCancellation() {
    return this.show_cancel;
  }

  canOpenPtCancellation() {
    return this.show_cancel_pt;
  }

}

export class Club {
  id;
  name;
  email;
  address;
  phone;

  constructor(props) {
    Object.assign(this, props);
    this.address = new Address(props.address)
  }
}

export class Address {
  id;
  address_1;
  address_2;
  city;
  state;
  zip;
  country_code;

  constructor(props) {
    Object.assign(this, props)
  }
}